import OutageBannerWithData from './OutageBannerWithData'
import OutageBannerWithoutData from './OutageBannerWithoutData'

const OutageBanner = OutageBannerWithData

export default OutageBanner
export { OutageBannerWithoutData }
